import { call, put, takeLatest } from 'redux-saga/effects';
import _ from 'lodash';
import Metrics from 'services/metrics';
import invariant from 'invariant';
import { GetRegion } from 'constants.js';
import { LOAD_USER_FACEBOOK } from '../constants';
import {
  pendingFacebook,
  errorUserLogInEmail,
  actionUserIsLoggedIn,
} from '../actions';
import { isLoggedin, getPaywayProfile } from '../service';

export function* doLoginWithFacebook({ payload }) {
  yield put(pendingFacebook());
  let request;
  try {
    const p = { ...payload };
    delete p.setShowFacebookError;
    delete p.setMessageFacebookError;
    const { login, ...params } = p;
    params.includepaywayprofile = 1;
    request = yield call(isLoggedin, params);
    const { response, errors, status } = request;

    if (_.parseInt(status) !== 0 && !_.isEmpty(errors))
      throw new Error(request);
    Metrics.newEvent({
      event: 'Login',
      eventCategory: 'landing',
      eventAction: 'inicia sesion',
      eventLabel: 'exitoso - facebook',
    });
    const userPaywayaProfile = yield call(getPaywayProfile, {
      token: response.user_token,
      api_version: 'v7',
    });
    response.paywayProfile = userPaywayaProfile.response;

    const metricsParams = {
      event: 'login',
      method: 'facebook',
      user_id: response.user_id,
    };
    Metrics.newEvent(metricsParams);

    yield put(actionUserIsLoggedIn({ login, response }));
  } catch (error) {
    const { errors } = error.response.data;
    const { setShowFacebookError, setMessageFacebookError } = { ...payload };
    Metrics.newEvent({
      event: 'Error',
      eventCategory: 'Errores',
      eventAction: 'Error',
      eventLabel: `Iniciar_Sesión_Facebook-(WEB)_API_${errors?.code}-${
        errors.error?.type === 'internal' ? 'int' : 'ext'
      }`,
      Pais: GetRegion(),
      Device: 'web',
    });
    yield put(errorUserLogInEmail(errors));
    setShowFacebookError(true);
    setMessageFacebookError(errors.error?.[0]);
  }
}

export default function* loginFacebookSaga() {
  yield takeLatest(LOAD_USER_FACEBOOK.ACTION, doLoginWithFacebook);
}
